export default "__VITE_ASSET__i4ExTh4x__"